var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnselectStat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 19"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 16",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 4",
    d: "M634.355 11.725h-4.872v-8.8a1.039 1.039 0 0 0-1.044-1.035h-5.926a1.039 1.039 0 0 0-1.044 1.035V8.1h-4.881a1.039 1.039 0 0 0-1.044 1.035v13.384a1.044 1.044 0 0 0 2.087 0V10.167h3.838v12.352a1.039 1.039 0 0 0 1.044 1.035 1.039 1.039 0 0 0 1.044-1.035V3.961h3.843v8.7c0 .032-.01.063-.01.1v9.76a1.039 1.039 0 0 0 1.044 1.035h.01a1.039 1.039 0 0 0 1.044-1.035v-8.727h3.828v8.725a1.044 1.044 0 0 0 2.087 0v-9.76a1.039 1.039 0 0 0-1.044-1.035",
    transform: "translate(-614.472 -1.723)",
    style: {
      fill: "#00402e"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnselectStat);
export default __webpack_public_path__ + "static/media/ic-unselect-stat.a8058339b28d6e0fae0500a89d968673.svg";
export { ForwardRef as ReactComponent };